import DailyMockBannerFormPage from "./DailyMockBannerFormPage";

export default function DailyMockBannerAdd() {
  return (
    <DailyMockBannerFormPage
      mode="add"
      pageTitle="Add Daily Mock Banner"
      breadcrumbTitle="Add Daily Mock Banner"
      backPath="/daily-mock-banner"
      successMessage="Daily mock banner added successfully"
    />
  );
}
